module.exports = __webpack_public_path__ + "static/img/stamp_11.ec5ae2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keepgoing/stamp_11.jpg
// module id = 3zfs
// module chunks = 7